import { SET_REGIONS } from './types';
import Region from '../../models/Region';

export function addRegions(regions: Region[]) {
  return {
    type: SET_REGIONS,
    payload: regions,
  };
}
